export default __webpack_public_path__ + "static/feature6banner-91f204f1adb9f155a8c315049e5b1001.svg";